var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sectorsRow{height:30vh}.sectorsRow2{height:15vh}.sectorDash{color:#fff;height:15vh;background-image:url(" + escape(require("../../assets/img/login.jpg")) + ")!important;border:5px solid #fff;border-radius:10px}.sectorDash:hover{cursor:pointer;background:#455a64}.sectorDashDis{height:15vh;color:#fff;background:#455a64!important;border:5px solid #fff;border-radius:10px}.sectorDashDis:hover{cursor:pointer;background:#455a64}", ""]);

// exports
